import React from "react";

const BillingIcon = (props) => {
  let height = props?.height ? props?.height : 20;
  let width = props?.width ? props?.width : 20;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 512 512"
    >
      <g>
        <path
          d="M410.667 0H101.333C75.734 0 56 19.734 56 45.333v421.334C56 492.266 75.734 512 101.333 512H410.667C436.266 512 456 492.266 456 466.667V45.333C456 19.734 436.266 0 410.667 0zM408 448H104V64h304v384z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
        />
        <path
          d="M160 192h192c8.832 0 16-7.168 16-16s-7.168-16-16-16H160c-8.832 0-16 7.168-16 16s7.168 16 16 16zM352 224H160c-8.832 0-16 7.168-16 16s7.168 16 16 16h192c8.832 0 16-7.168 16-16s-7.168-16-16-16zM352 288H160c-8.832 0-16 7.168-16 16s7.168 16 16 16h192c8.832 0 16-7.168 16-16s-7.168-16-16-16zM240 352h-80c-8.832 0-16 7.168-16 16s7.168 16 16 16h80c8.832 0 16-7.168 16-16s-7.168-16-16-16z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
        />
      </g>
    </svg>
  );
};

export default BillingIcon;
